<div [class]="'user-badge '+state()">
    @if (state() === 'extended') {
        <div class="user-badge__wrapper">
            <div class="user-badge__logo"></div>
            <div class="user-badge__text">{{ user() || 'Данных нет'}}</div>
        </div>
    } @else {
        <div class="user-badge__logo"></div>
    }
</div>
